import axios from 'axios';

const baseApi = '/site'

class SiteService {

  getBike (slug){
    return axios.get(`${baseApi}/bike/${slug}`)
  }

  getAllBikesByUser (_id){
    return axios.get(`${baseApi}/all/${_id}`)
  }

  getAllBikes (){
    return axios.get(`${baseApi}/all`)
  }

  async searchBikes (city, coordinates, period){
     const url = `${baseApi}/search/${city}/${coordinates}/${period}`
     return axios.get(url)
  }


   async querySearch(queryString) {
      let query = queryString || "Brasil"
      //TODO: criar conta para a pedale
      let url = `https://secure.geonames.org/searchJSON?q=${query}&maxRows=10&username=elisson.kario&country=BR`
      url = encodeURI(url);
      return await axios.get(url)
   }

  getUfs (){
      return axios.get(`${baseApi}/ufs`)
   }

   getCities ( state_id, name ){
      const query = `?state_id=${state_id}&name=${name}`
      return axios.get(`${baseApi}/cities${query}`)
   }

   getBikeRatings (bikeId, perPage, page){
      const query = `?perPage=${perPage}&page=${page}`

      return axios.get(`${baseApi}/ratings/${bikeId}${query}`)
   }

   getBikes (env){
     let url = env === "development" ? `http://localhost:3000/api/v1/site/bikes` : `https://pedale.net.br/api/v1/site/bikes`
      return axios.get(url)
   }

   getPolitic(type){
      return axios.get(`${baseApi}/politic/${type}`)
   }

   async getStates() {
      return await axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
   }

   async getCitiesById(id) {
      return await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${id}/municipios`)
   }

   async getBlogPosts() {
     return await axios.get('https://pedale.net.br/blog/wp-json/wp/v2/posts?_embed')
   }

}

export default new SiteService();
